import { render } from "./AllocationContentHeader.vue?vue&type=template&id=2df6f16a&scoped=true"
import script from "./AllocationContentHeader.vue?vue&type=script&lang=js"
export * from "./AllocationContentHeader.vue?vue&type=script&lang=js"

import "./AllocationContentHeader.vue?vue&type=style&index=0&id=2df6f16a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df6f16a"]])

export default __exports__